import React from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import { emptyValue } from "utils/emptyValue";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import type PaymentBankTransferDetailViewModel from "viewModels/finance/payments/bankTransfer/paymentBankTransferDetailViewModel";
import Section from "views/common/section";

export interface CounterpartiesInfoProps {
  vm: PaymentBankTransferDetailViewModel;
}

const CounterpartiesInfo = observer((props: CounterpartiesInfoProps) => {
  const { vm } = props;

  return (
    <Section title={vm.translate("counterpartiesInfoTitle")} context>
      <Form.Row>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("counterpartyAccountNumber")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="counterpartyAccountNumber"
            valueFormatter={value => vm.formatBankAccount(value)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("counterpartyBank")}</Form.Label>
          <FakeInput target={vm.item} property="counterpartyBank" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("counterpartyAccountType")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="counterpartyAccountType"
            valueFormatter={value => vm.translateBankAccountType(value) ?? emptyValue}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("counterpartyName")}</Form.Label>
          <FakeInput target={vm.item} property="counterpartyName" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("counterpartyAddress")}</Form.Label>
          <FakeInput target={vm.item} property="counterpartyAddress" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("bankAccount")}</Form.Label>
          <FakeInput target={vm.item} property="bankAccount" valueFormatter={value => formatBankAccount(value)} />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default CounterpartiesInfo;
